import React, { Component } from 'react';
import baseUrl from './constants/config'
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Question from './question';
import './css/questionDisplay.css';

const batchSize = 50
class QuestionDisplay extends Component {

  constructor (props) {
    super(props)
    this.state = {
      questionList: [],
      notes: [],
      isDelete: [],
      page: 0,
      showStuff: false,
      pageInput: '0'
    };
    this.fetchQuestion(this.state.page)
    this.jumpToPage = this.jumpToPage.bind(this)
    this.setPageInput = this.setPageInput.bind(this)
  }

  handleErrors(response) {
    if (!response.ok) {
      console.log('Something possibly went wrong. Please refresh the page.')
    }
    return response;
  }

  fetchQuestion (page) {
    var url = 'trivia/api/getAllQuestions?triviaCategoryPrefix=fgo&batchSize=' + 
      batchSize + 
      '&page=' + page
    console.log(url)
    fetch(baseUrl + url, { 
        method: 'GET'
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
        var listLength = data['questionList'].length
        if (listLength === 0) {
          return
        }
        var notes = []
        var isDeleted = []
        for (var i = 0; i < listLength; i++) {
          notes[i] = ''
          isDeleted[i] = false
        }
        this.setState({ 
          questionList: data['questionList'],
          notes: notes,
          isDeleted: isDeleted,
          showStuff: true
        })
      });
  }

  renderQuestion(contents) {
    return contents.map((questionDto, j) => (
        <Question key = {j} questionDto = {questionDto}></Question>
      ))
  }

  changeIsDeleted(index) {
    var isDeleted = this.state.isDeleted
    isDeleted[index] = !isDeleted[index]
    this.setState({ 
      isDeleted: isDeleted,
    })
  }

  attachNotes(evt, index) {
    var notes = this.state.notes
    notes[index] = evt.target.value

    this.setState({ 
      notes: notes,
    })
  }

  submit() {
    var items = []
    for (var i = 0; i < this.state.questionList.length; i++) {
      var item = {
        'type': this.state.questionList[i].type, 
        'id': this.state.questionList[i].id, 
        'note': this.state.notes[i],
        'isDeleted': this.state.isDeleted[i]
      }
      if (this.state.notes[i] !== '' || this.state.isDeleted[i]) {
        items.push(item)
      }
    }
    console.log(items)

    fetch(baseUrl + 'trivia/api/reportQuestion', { 
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          content: items
        })
      })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data => {
      });


    alert('submitted')
  }

  changePage(next) {
    if (next) {
      var nextPage = this.state.page + batchSize
    } else {
      var nextPage = this.state.page - batchSize
    }
    this.jumpToPage(nextPage)
  }

  jumpToPage(page) {
    this.setState({
        questionList: [],
        notes: [],
        isDelete: [],
        page: page,
        showStuff: false,
        pageInput: page
      })
    this.fetchQuestion(page)
  }

  setPageInput(event) {
    event.preventDefault()
    this.jumpToPage(parseInt(this.state.pageInput, 10))
  }

  updatePageInputValue(evt) {
    this.setState({
      pageInput: evt.target.value
    });
  }
    

  render() {
    if (!this.state.showStuff) {
      return (<div> loading </div>);
    }
    const questionItems = this.state.questionList.map((questionList, i) =>
      <div className='questionRow' key = {i}>
        {this.state.isDeleted[i] && <p>deleted</p>}
        <button className='actionBtn' onClick={() => {this.changeIsDeleted(i)}}>
          Mark delete/undelete
        </button>
        <textarea 
              rows="4"
              cols="50"
              type="text" 
              placeholder = "Attach a note" 
              className = "Text-Input"
              value={this.state.notes[i]}
              onChange={evt => this.attachNotes(evt, i)} />
        {this.renderQuestion(questionList['contents'])}
      </div>
    );

    return (
        <div>
          <button className='actionBtn' 
            onClick={() => {this.changePage(false)}}>
            Previous
          </button>
          <button className='actionBtn' 
            onClick={() => {this.changePage(true)}}>
            Next
          </button>
          <p></p>
          <form className="commentForm" onSubmit={this.setPageInput}>
            < input type="text" 
              placeholder = "Jump to question" 
              className = "Text-Input"
              value={this.state.pageInput}
              onChange={evt => this.updatePageInputValue(evt)}/>
            <button className='actionBtn' type = "submit">Set questionId</button>
          </form>


          <ul className = "QuestionList">{questionItems}</ul>


          <button className='actionBtn' onClick={() => {this.submit()}}>
            submit
          </button>

          <p></p>
          <button className='actionBtn' 
            onClick={() => {this.changePage(false)}}>
            Previous
          </button>
          <button className='actionBtn' 
            onClick={() => {this.changePage(true)}}>
            Next
          </button>
          <p></p>
          <form className="commentForm" onSubmit={this.setPageInput}>
            < input type="text" 
              placeholder = "Jump to question" 
              className = "Text-Input"
              value={this.state.pageInput}
              onChange={evt => this.updatePageInputValue(evt)}/>
            <button className='actionBtn' type = "submit">Set questionId</button>
          </form>
          
        </div>
    );
  }
}

export default QuestionDisplay;



// WEBPACK FOOTER //
// ./src/components/questionDisplay.js